import type React from 'react';
import type { MutableRefObject } from 'react';

import AiMessageItem from './ai-message-item';
import UserMessageItem from './user-message-item';

import type { ChatMessage } from 'containers/admin/clients/client/tabs-components/ai-assistant/hooks/use-active-input-part';

import Icons from 'assets/icons';

interface MessageItemProps {
  message: ChatMessage & {
    content?: string;
    loading?: boolean;
  };
  oktaUserId: string;
  clientId: string | number;
  conversationId: string;
  feedbackCloseRef: MutableRefObject<(() => void) | null>;
  onRegenerateMessage?: (messageId: string) => void;
  onEditMessage?: (messageId: string) => void;
  isReadOnly?: boolean;
  isRegenerateDisabled?: boolean;
}

const MessageItem = ({
  message,
  oktaUserId,
  clientId,
  conversationId,
  feedbackCloseRef,
  onRegenerateMessage,
  onEditMessage,
  isReadOnly,
  isRegenerateDisabled,
}: MessageItemProps): React.JSX.Element => {
  if (message.loading) {
    return (
      <div className="animate-fade-in flex w-fit align-center gap-3 rounded-md border border-gray-200 bg-gray-50 px-4 py-3">
        <Icons.Spinner customClass="w-5 h-5 animate-spin" />
        <p className="text-gray-600">{message.content}</p>
      </div>
    );
  }

  if (message.isUser) {
    return (
      <UserMessageItem
        content={message.content ?? ''}
        isDisabled={!!isReadOnly}
        onEdit={
          onEditMessage && !isReadOnly
            ? () => onEditMessage(message.id)
            : undefined
        }
      />
    );
  }

  return (
    <AiMessageItem
      message={message}
      oktaUserId={oktaUserId}
      clientId={clientId}
      conversationId={conversationId}
      feedbackCloseRef={feedbackCloseRef}
      onRegenerateMessage={onRegenerateMessage}
      isReadOnly={isReadOnly}
      isRegenerateDisabled={isRegenerateDisabled}
    />
  );
};

export default MessageItem;
